import { render, staticRenderFns } from "./kaiyiinformedconsent.vue?vue&type=template&id=737d6466&"
var script = {}
import style0 from "./kaiyiinformedconsent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports